import React, { useEffect, useState } from 'react'
import './index.scss'
import HomeCard from './HomeCard'
import MenuBarLanding from '../MenubarLanding'
import { Link } from 'react-router-dom'

const Home = () => {
  const colors = ['#8c458a', '#D9991E', '#9DAD2A', '#8c458a', '#D9991E']
  const letters = 'WAIMA'.split('')

  const [language, setLanguage] = useState(localStorage.getItem('lang') || 'es')

  useEffect(() => {
    const handleLanguageChange = () => {
      setLanguage(localStorage.getItem('lang') || 'es')
    }

    window.addEventListener('languageChange', handleLanguageChange)

    return () =>
      window.removeEventListener('languageChange', handleLanguageChange)
  }, [])

  return (
    <div className="size-window">
      <section className="background-wrapper">
        <MenuBarLanding />
        <div className="hero-wrapper-primary">
          <div className="hero-content">
            <div className="home-content-grid-wrapper">
              <div className="text-box-wrapper">
                <h1>
                  {language === 'es' ? 'FUNDACIÓN ' : 'Foundation '}

                  <span
                    className="text-shadow-white"
                    style={{ marginRight: '20px' }}
                  >
                    {letters.map((letter, index) => (
                      <span key={index} style={{ color: colors[index] }}>
                        {letter}
                      </span>
                    ))}
                  </span>
                </h1>

                <p>
                  {language === 'es'
                    ? 'Apoyando capacidades creativas.'
                    : 'Supporting Creative Capacities.'}
                </p>

                <div className="button-switch">
                  
                  <div className="btn-option hover-state-1">
                    <Link className="link-txt" to="/about">
                      {language === 'es' ? 'Conoce Más' : 'Learn More'}
                    </Link>
                  </div>

                  <div className="btn-option hover-state-2">
                    <Link className="link-txt" to="/contact">
                      {language === 'es' ? 'Contáctanos' : 'Contact Us'}
                    </Link>
                  </div>

                  <div className="switch-block"></div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <HomeCard />
    </div>
  )
}

export default Home
